module.exports = __webpack_public_path__ + "static/media/messages.f3c82928.svg";